<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.RAFFLE_WINNERS_LIST_TOOLS.TITLE' | translate }}</h4>

  <button mat-stroked-button type="button" (click)="previewDraw()">
    {{ 'PRESENTER.RAFFLE_DRAW_TOOLS.PREVIEW_DRAW' | translate }}
  </button>

  <button mat-stroked-button type="button" (click)="resetPreviewDraw()">
    {{ 'PRESENTER.RAFFLE_DRAW_TOOLS.RESET_PREVIEW' | translate }}
  </button>

  @if (!isTemplateMode) {
    <div class="raffle-item-select">
      @if (raffleItemsLoaded$ | async) {
        <mat-form-field>
          <mat-label>{{ 'PRESENTER.RAFFLE_WINNERS_LIST_TOOLS.RAFFLE_ITEM' | translate }}</mat-label>
          <mat-select [formControl]="itemControl">
            @for (item of raffleItems$ | async; track item.uuid) {
              <mat-option [value]="item.raffle_item?.uuid">{{ item.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <div class="raffle-item-spinner-container">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
      }
    </div>
  }

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="primaryColorControl"
    labelTranslateKey="PRESENTER.RAFFLE_WINNERS_LIST_TOOLS.PRIMARY_COLOUR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="accentColorControl"
    labelTranslateKey="PRESENTER.RAFFLE_WINNERS_LIST_TOOLS.ACCENT_COLOUR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-presenter-tools-advanced-options-container>
    <mat-form-field>
      <mat-label>{{ 'PRESENTER.RAFFLE_WINNERS_LIST_TOOLS.ROWS' | translate }}</mat-label>
      <input matInput type="number" min="1" max="100" [formControl]="rowsControl" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'PRESENTER.RAFFLE_WINNERS_LIST_TOOLS.COLUMNS' | translate }}</mat-label>
      <input matInput type="number" min="1" max="10" [formControl]="columnsControl" />
    </mat-form-field>

    <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>
  </gb-presenter-tools-advanced-options-container>
</div>
